const TruckIcon = ({ fill, className }) => {
  return (
    <svg
      className={className}
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.16649 8.33236C2.61421 8.33236 2.16649 8.78008 2.16649 9.33236C2.16649 9.88465 2.61421 10.3324 3.16649 10.3324L11.1665 10.3324C11.7188 10.3324 12.1665 9.88465 12.1665 9.33236C12.1665 8.78008 11.7188 8.33236 11.1665 8.33236L3.16649 8.33236Z"
        fill={fill || "#FF0000"}
      />
      <path
        d="M3.16649 12.3324C2.61421 12.3324 2.16649 12.7801 2.16649 13.3324C2.16649 13.8846 2.61421 14.3324 3.16649 14.3324L8.49983 14.3324C9.05211 14.3324 9.49983 13.8846 9.49983 13.3324C9.49983 12.7801 9.05211 12.3324 8.49983 12.3324L3.16649 12.3324Z"
        fill={fill || "#FF0000"}
      />
      <path
        d="M21.7103 18.7791C22.1231 18.6568 22.5605 18.5912 23.0133 18.5912C25.0792 18.5912 26.8243 19.9578 27.385 21.8319C27.9745 21.8319 28.2254 21.5846 28.2254 21.1838L28.2254 17.2949C28.2254 13.5758 25.363 10.5218 21.7103 10.1943L21.7103 18.7791Z"
        fill={fill || "#FF0000"}
      />
      <path
        d="M9.98301 21.1838C8.90355 21.1838 8.02847 22.0543 8.02847 23.1282C8.02847 24.2021 8.90355 25.0727 9.98301 25.0727C11.0625 25.0727 11.9376 24.2021 11.9376 23.1282C11.9376 22.0543 11.0625 21.1838 9.98301 21.1838Z"
        fill={fill || "#FF0000"}
      />
      <path
        d="M21.0587 23.1282C21.0587 22.0543 21.9338 21.1838 23.0133 21.1838C24.0927 21.1838 24.9678 22.0543 24.9678 23.1282C24.9678 24.2021 24.0927 25.0727 23.0133 25.0727C21.9338 25.0727 21.0587 24.2021 21.0587 23.1282Z"
        fill={fill || "#FF0000"}
      />
      <path
        opacity="0.4"
        d="M16.5801 4.33301L7.29834 4.33301C6.446 4.33293 5.68019 4.33286 5.06033 4.41577C4.38359 4.50628 3.68932 4.71645 3.12063 5.28221C2.79993 5.60126 2.59289 5.96003 2.45699 6.33301L11.1665 6.33301C12.8234 6.33301 14.1665 7.67615 14.1665 9.33301C14.1665 10.9358 12.9096 12.245 11.3276 12.3288C11.4391 12.6427 11.4998 12.9808 11.4998 13.333C11.4998 14.9899 10.1567 16.333 8.49983 16.333H2.16651L2.16651 19.9407C2.16647 20.5017 2.16644 21.0065 2.20456 21.425C2.24549 21.8742 2.33843 22.3494 2.60294 22.8052C2.88885 23.2979 3.30008 23.707 3.7953 23.9914C4.25344 24.2546 5.15785 24.3729 5.60938 24.4136C6.16617 26.2939 7.91431 27.6663 9.98467 27.6663C12.0506 27.6663 13.7957 26.2997 14.3564 24.4256L18.6432 24.4256C19.2039 26.2997 20.949 27.6663 23.0149 27.6663C25.0809 27.6663 26.826 26.2997 27.3867 24.4257C28.8663 24.2422 30.6237 23.0577 30.8081 21.5857C30.8335 21.383 30.8333 21.1614 30.8331 20.9351L30.8331 17.296C30.8331 12.1298 26.7828 7.90482 21.6689 7.5923C21.5779 6.91905 21.3265 5.84796 20.7578 5.28221C20.1891 4.71645 19.4948 4.50628 18.8181 4.41577C18.1982 4.33286 17.4324 4.33293 16.5801 4.33301Z"
        fill={fill || "#FF0000"}
      />
    </svg>
  );
};

export default TruckIcon;
